module.exports = __webpack_public_path__ + "static/media/profile.3d25d9d0.svg";